/* eslint-disable react-hooks/exhaustive-deps */
import styles from './EditShift.module.css'
import React, { useEffect, useState } from "react";
import {
    TextField,
    Button,
    Select,
    MenuItem,
    Autocomplete,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import {
    doorToDoorPolicy,
    editShift,
    GetActiveProjects,
    getClientSitescontact,
    GetJobWithWorkersModel,
    getPaceSiteContacts,
    getWorkersFromJob,
    saveJobVersionHistory,
    sendPushNotifications,
    updateJobWorkerRows
} from "../../../../../api/apiCall";
import { useAuth } from "../../../../../auth/auth";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { diff } from 'deep-diff';
import { Spin } from "antd";
import { calculateHours } from "../../../../../utils/utils";
import { formatDiffs, formatFieldValue, FormValues } from '../../../../../utils/shiftUtils';

const EditShift = ({ id, week, year, shiftData, setShiftData, currentCell, connection }: any) => {
    const { state } = useAuth();
    const [projects, setProjects] = useState([]);
    const [oldShiftData, setOldShiftData] = useState([]);
    const [paceSiteContacts, setPaceSiteContacts] = useState<any>([]);
    const [clientSiteContacts, setClientSiteContacts] = useState<any>([]);
    const [date] = useState<any>(shiftData.jobDate);
    const [loading, setLoading] = useState(false);
    const [selectedShiftType, setSelectedShiftType] = useState<number>(shiftData.shiftType);
    const [workers, setWorkers] = useState<any>([]);
    const [workersIds, setWorkersIds] = useState<any>([]);
    const [workersRowIds, setWorkersRowIds] = useState([]);

    const { register, control, formState: { errors }, reset, setValue } = useForm<FormValues>({
        defaultValues: {
            id: (shiftData.id === id ? id : 'null'),
            projectId: shiftData?.projectId,
            week: shiftData.week,
            rowIndex: currentCell.rowIndex,
            columnIndex: currentCell.colIndex,
            location: shiftData.location,
            region: shiftData.region,
            jobDate: format(shiftData.jobDate, 'dd/MM/yyyy'),
            shiftType: selectedShiftType,
            jobDescription: shiftData.jobDescription,
            requiredWorkers: shiftData.requiredWorkers,
            postCode: shiftData.postCode,
            whatsAppName: shiftData.whatsAppName,
            jobStatus: shiftData.jobStatus,
            startTime: shiftData.startTime.slice(11, 16),
            endTime: shiftData.endTime.slice(11, 16),
            hours: shiftData.hours,
            clientSiteContact: shiftData?.clientSiteContact,
            onCallNumber: shiftData?.onCallNumber,
            jobNumber: shiftData.jobNumber,
            labourOrderNR: shiftData.labourOrderNR,
            additionalInformation: shiftData.additionalInformation,
            invoice: shiftData.invoice,
            plants_Materials: shiftData.plants_Materials,
            vehicleRegistration: shiftData.vehicleRegistration,
            hotelStatus: shiftData.hotelStatus
        }
    })

    useEffect(() => {
        getWorkers();
        setOldShiftData(shiftData);
        GetActiveProjects(state.user?.token).then(setProjects);
        getPaceSiteContacts(state.user?.token).then(setPaceSiteContacts);
        getClientSitescontact(state.user?.token).then(setClientSiteContacts);
    }, []);

    const getWorkers = async () => {
        const response = await getWorkersFromJob(state.user?.token, id);
        if (response) {
            setWorkers(response)
            const userIds = response
                .filter((item: { userId: null; }) => item.userId !== null)
                .map((item: { userId: any; }) => item.userId);

            setWorkersIds(userIds)

            const workersRowId = response
                .filter((item: { id: null; userId: null }) => item.userId !== null)
                .map((item: { id: any; }) => item.id);

            setWorkersRowIds(workersRowId)
        }
    };

    let updated = [...workers];

    const handleAutoSave = async (field: any, value: any) => {
        setLoading(true);
        const updatedData = {
            ...shiftData,
            [field]: formatFieldValue(field, value)
        };

        const changes = diff(oldShiftData, updatedData);

        const filteredChanges = changes?.filter(d => d.kind === "E");
        if (!filteredChanges || filteredChanges.length === 0) {
            setLoading(false);
            return;
        }

        const formattedDiffs = formatDiffs(changes)
        const changesJsonToString = JSON.stringify(formattedDiffs);

        try {
            const response: any = await editShift(state.user?.token, updatedData);
            if (response.status === 200) {
                setOldShiftData(updatedData);
                await saveJobVersionHistory(state.user?.token, id, changesJsonToString);
                setTimeout(() => {
                    setLoading(false);
                }, 500)

                if (field === 'postCode' || field === 'startTime' || field === 'endTime') {
                    handleDoorToDoorValidation(updatedData);
                }

                const jobWorkersModel = await GetJobWithWorkersModel(state.user?.token, id);
                await connection.invoke("EditJob", `${week}-${year}`, jobWorkersModel);
            } else {
                toast.error("Something went wrong!");
                setLoading(false);
            }
        } catch (error) {
            toast.error("An error occurred while saving changes.");
            console.error("Error in auto save:", error);
            setLoading(false);
        }
    };

    const handleDoorToDoorValidation = async (updatedData: any) => {
        for (const worker of workersRowIds) {
            const doorPolicy = await doorToDoorPolicy(state.user?.token, worker, calculateHours(format(updatedData.startTime, 'HH:mm'), format(updatedData.endTime, 'HH:mm')));

            const workerIndex = updated.findIndex((row: any) => row.id === worker);
            if (workerIndex !== -1) {
                if (doorPolicy.isOverLimit) {
                    toast.error(doorPolicy.message + ' - ' + updated[workerIndex].fullName);

                    const existingNotes = updated[workerIndex].notes;

                    const cleanedNotes =
                        existingNotes && existingNotes !== 'null'
                            ? existingNotes.replace(/\(Door.*?m\)/g, '').trim()
                            : '';

                    updated[workerIndex] = {
                        ...updated[workerIndex],
                        notes: cleanedNotes
                            ? cleanedNotes + ' ' + doorPolicy.message
                            : doorPolicy.message,
                        colorIdentifier: '#f28519',
                    };
                } else {
                    updated[workerIndex] = {
                        ...updated[workerIndex],
                        colorIdentifier: null,
                        notes: (() => {
                            const existingNotes = updated[workerIndex].notes;
                            return existingNotes && existingNotes !== 'null'
                                ? existingNotes.replace(/\(Door.*?m\)/g, '').trim()
                                : existingNotes;
                        })(),
                    };
                }
            }
        }
        setWorkers(updated);
        await updateJobWorkerRows(state.user?.token, updated);
    }

    useEffect(() => {
        if (connection) {
            connection.on('EditJob', (jobModel: any) => {
                if (shiftData.id === jobModel.job.id) {
                    setShiftData((prevData: any) => ({
                        ...prevData,
                        ...jobModel.job
                    }));
                    setOldShiftData((prevData: any) => ({
                        ...prevData,
                        ...jobModel.job
                    }));
                    setSelectedShiftType(jobModel.job.shiftType)
                    reset({
                        id: jobModel.job.id,
                        projectId: jobModel.job.projectId,
                        week: jobModel.job.week,
                        rowIndex: jobModel.job.rowIndex,
                        columnIndex: jobModel.job.columnIndex,
                        location: jobModel.job.location,
                        region: jobModel.job.region,
                        jobDate: format(jobModel.job.jobDate, 'dd/MM/yyyy'),
                        shiftType: jobModel.job.shiftType,
                        jobDescription: jobModel.job.jobDescription,
                        requiredWorkers: jobModel.job.requiredWorkers,
                        postCode: jobModel.job.postCode,
                        whatsAppName: jobModel.job.whatsAppName,
                        jobStatus: jobModel.job.jobStatus,
                        startTime: jobModel.job.startTime.slice(11, 16),
                        endTime: jobModel.job.endTime.slice(11, 16),
                        hours: jobModel.job.hours,
                        clientSiteContact: jobModel.job?.clientSiteContact,
                        onCallNumber: jobModel.job?.onCallNumber,
                        jobNumber: jobModel.job.jobNumber,
                        labourOrderNR: jobModel.job.labourOrderNR,
                        additionalInformation: jobModel.job.additionalInformation,
                        invoice: jobModel.job.invoice,
                        plants_Materials: jobModel.job.plants_Materials,
                        hotelStatus: jobModel.job.hotelStatus,
                        vehicleRegistration: jobModel.job.vehicleRegistration,
                        longitude: jobModel.job.longitude,
                        latitude: jobModel.job.latitude,
                    });
                }
            })

            return () => {
                connection.off('EditJob');
            }
        }
    }, [connection]);

    return (
        <>
            <form className={styles.marginTop}>
                <div className="center-content">
                    <TextField
                        label="Week"
                        type="number"
                        {...register("week")}
                        size="small"
                        disabled
                        style={{ width: "7%", margin: 10 }}
                    />
                    <Controller
                        name="projectId"
                        control={control}
                        rules={{ required: "Project is required" }}
                        render={({ field }) => (
                            <Autocomplete
                                options={projects}
                                getOptionLabel={(option: any) =>
                                    `${option.company.companyName} - ${option.projectName}`
                                }
                                isOptionEqualToValue={(option: any, value: any) =>
                                    option.id === value?.id
                                }
                                value={
                                    projects.find((p: any) => p.id === shiftData.projectId) || null
                                }
                                onChange={(_, value) => {
                                    field.onChange(value?.id || "");
                                    setShiftData({ ...shiftData, projectId: value?.id });
                                }}
                                onBlur={(e: any) =>
                                    handleAutoSave("projectId", shiftData.projectId)
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Client-Project"
                                        size="small"
                                        error={!!errors.projectId}
                                        helperText={errors.projectId?.message}
                                        sx={{ width: "260px", margin: 1.2 }}
                                    />
                                )}
                            />
                        )}
                    />
                    <TextField
                        label="WhatsApp Name"
                        type="text"
                        size="small"
                        error={!!errors.whatsAppName}
                        {...register("whatsAppName")}
                        style={{ width: "20%", margin: 10 }}
                        onBlur={(e: any) => handleAutoSave('whatsAppName', e.target.value.trim())}
                    />
                    <TextField
                        select
                        size="small"
                        label="Type of Work"
                        value={shiftData.region}
                        style={{ margin: 10, width: '20%' }}
                        {...register("region")}
                        onBlur={(e: any) => handleAutoSave('region', e.target.value)}
                        onChange={(event) => setShiftData({ ...shiftData, region: event.target.value })}
                    >
                        <MenuItem value={"N/A"}>N/A</MenuItem>
                        <MenuItem value={'Price Work'}>Price Work</MenuItem>
                        <MenuItem value={'Labour'}>Labour</MenuItem>
                        <MenuItem value={'X Other'}>X Other</MenuItem>
                    </TextField>
                </div>
                <div className="center-content">
                    <TextField
                        label="Location"
                        type="text"
                        size="small"
                        error={!!errors.location}
                        {...register("location")}
                        style={{ width: "18%", margin: 10 }}
                        onBlur={(e: any) => handleAutoSave('location', e.target.value.trim())}
                    />
                    <TextField
                        label={"Post Code"}
                        type="text"
                        size="small"
                        error={!!errors.postCode}
                        {...register("postCode")}
                        style={{ width: "17%", margin: 10 }}
                        onBlur={(e: any) => handleAutoSave('postCode', e.target.value.trim())}
                    />
                    <TextField
                        label="Date"
                        id="outlined-basic"
                        variant="outlined"
                        type="text"
                        {...register("jobDate")}
                        disabled
                        size="small"
                        style={{ margin: 10, width: "11.5%" }} />
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        size="small"
                        error={!!errors.shiftType}
                        value={selectedShiftType}
                        {...register("shiftType", {
                            required: "Shift Type Workers is required"
                        })}
                        onBlur={(e: any) => handleAutoSave('shiftType', e.target.value)}
                        onChange={(e: any) => setSelectedShiftType(e.target.value)}
                        style={{ height: 40, marginTop: 10, margin: 10, width: '20%' }}
                    >
                        <MenuItem value={0}>Day Shift</MenuItem>
                        <MenuItem value={1}>Night Shift</MenuItem>
                        <MenuItem value={2}>Weekend</MenuItem>
                    </Select>
                </div>
                <div className="center-content">
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        size="small"
                        error={!!errors.jobStatus}
                        {...register("jobStatus", {
                            required: "Shift Type Workers is required"
                        })}
                        value={shiftData.jobStatus}
                        onBlur={(e: any) => handleAutoSave('jobStatus', e.target.value)}
                        onChange={async (event) => {
                            setShiftData({ ...shiftData, jobStatus: event.target.value });
                            if (event.target.value === 1) {
                                await sendPushNotifications(state.user?.token, id, workersIds);
                            }
                        }}
                        style={{ height: 40, marginTop: 10, margin: 10, width: '17%' }}
                    >
                        <MenuItem value={0}>Pending</MenuItem>
                        <MenuItem value={1}>Sent</MenuItem>
                        <MenuItem value={2}>Canceled</MenuItem>
                        <MenuItem value={3}>Invoiced</MenuItem>
                    </Select>
                    <TextField
                        label="Start Time"
                        type="time"
                        size="small"
                        {...register("startTime")}
                        style={{ width: "10.5%", margin: 10 }}
                        onBlur={(e: any) => handleAutoSave('startTime', e.target.value)}
                        onChange={(event: any) => {
                            if (currentCell.colIndex === 0 || currentCell.colIndex === 1) {
                                return;
                            } else {
                                const hour = parseInt(event.target.value.slice(0, 2), 10);
                                setValue('shiftType', hour >= 6 && hour < 18 ? 0 : 1)
                                setSelectedShiftType(hour >= 6 && hour < 18 ? 0 : 1)
                            }
                        }}
                    />
                    <TextField
                        label="End Time"
                        type="time"
                        size="small"
                        {...register("endTime")}
                        style={{ width: "10.5%", margin: 10 }}
                        onBlur={(e: any) => handleAutoSave('endTime', e.target.value)}
                    />
                    <TextField
                        label="Hours"
                        type="number"
                        size="small"
                        error={!!errors.hours}
                        {...register("hours")}
                        style={{ width: "10.5%", margin: 10 }}
                        onBlur={(e: any) => handleAutoSave('hours', e.target.value.trim())}
                    />
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        size="small"
                        error={!!errors.hotelStatus}
                        {...register("hotelStatus", {
                            required: "hotelStatus is required"
                        })}
                        onBlur={(e: any) => handleAutoSave('hotelStatus', e.target.value)}
                        value={shiftData.hotelStatus}
                        onChange={(event) => setShiftData({ ...shiftData, hotelStatus: event.target.value })}
                        style={{ height: 40, marginTop: 10, margin: 10, width: '17%' }}
                    >
                        <MenuItem value={0}>No Hotel Required</MenuItem>
                        <MenuItem value={1}>Hotel Pending Booking</MenuItem>
                        <MenuItem value={2}>Hotel Booked</MenuItem>
                    </Select>
                </div>
                <div className="center-content">
                    <Autocomplete
                        size="small"
                        freeSolo
                        value={shiftData.clientSiteContact}
                        style={{ margin: 10, width: '20%' }}
                        options={clientSiteContacts}
                        getOptionLabel={(option: any) => `${option || ""}`}
                        {...register("clientSiteContact")}
                        onBlur={(e: any) => handleAutoSave('clientSiteContact', e.target.value)}
                        renderInput={(params) =>
                            <TextField
                                label='Client Site Contact'
                                {...register("clientSiteContact")}
                                {...params}
                                inputProps={{
                                    ...params.inputProps,
                                    onKeyDown: (event) => {
                                        if (event.key === ' ') {
                                            event.stopPropagation();
                                        }
                                    },
                                }}
                            />
                        }
                    />
                    <Autocomplete
                        size="small"
                        freeSolo
                        value={shiftData.onCallNumber}
                        style={{ margin: 10, width: '16.5%' }}
                        options={paceSiteContacts}
                        getOptionLabel={(option: any) => `${option || ""}`}
                        {...register("onCallNumber")}
                        onBlur={(e: any) => handleAutoSave('onCallNumber', e.target.value)}
                        renderInput={(params) =>
                            <TextField
                                label='Pace On Call Number'
                                {...register("onCallNumber")}
                                {...params}
                                inputProps={{
                                    ...params.inputProps,
                                    onKeyDown: (event) => {
                                        if (event.key === ' ') {
                                            event.stopPropagation();
                                        }
                                    },
                                }}
                            />
                        }
                    />
                    <TextField
                        label="Job Number"
                        type="text"
                        size="small"
                        error={!!errors.jobNumber}
                        {...register("jobNumber")}
                        onBlur={(e: any) => handleAutoSave('jobNumber', e.target.value.trim())}
                        style={{ width: "13.5%", margin: 10 }} />
                    <TextField
                        label="Labour Order Nr"
                        type="number"
                        size="small"
                        error={!!errors.labourOrderNR}
                        {...register("labourOrderNR")}
                        style={{ width: "16.5%", margin: 10 }}
                        onBlur={(e: any) => handleAutoSave('labourOrderNR', e.target.value.trim())}
                    />
                </div>
                <div className="center-content">
                    <TextField
                        label="Description"
                        multiline
                        rows={6}
                        size="small"
                        error={!!errors.jobDescription}
                        {...register("jobDescription")}
                        style={{ width: "35%", margin: 10 }}
                        onBlur={(e: any) => handleAutoSave('jobDescription', e.target.value)}
                    />
                    <TextField
                        label="Plants / Materials"
                        multiline
                        rows={6}
                        size="small"
                        error={!!errors.plants_Materials}
                        {...register("plants_Materials")}
                        style={{ width: "34.5%", margin: 10 }}
                        onBlur={(e: any) => handleAutoSave('plants_Materials', e.target.value)}
                    />
                </div>
                <div className="center-content">
                    <TextField
                        label="Invoice"
                        type="text"
                        size="small"
                        error={!!errors.invoice}
                        {...register("invoice")}
                        style={{ width: "17%", margin: 10 }}
                        onBlur={(e: any) => handleAutoSave('invoice', e.target.value.trim())}
                    />
                    <TextField
                        label="Additional Information"
                        type="text"
                        size="small"
                        error={!!errors.additionalInformation}
                        {...register("additionalInformation")}
                        style={{ width: "16.5%", margin: 10 }}
                        onBlur={(e: any) => handleAutoSave('additionalInformation', e.target.value)}
                    />
                    <TextField
                        label="Vehicle Registration"
                        type="text"
                        size="small"
                        error={!!errors.vehicleRegistration}
                        {...register("vehicleRegistration")}
                        style={{ width: "16.5%", margin: 10 }}
                        onBlur={(e: any) => handleAutoSave('vehicleRegistration', e.target.value.trim())}
                    />
                    <TextField
                        label="Required Workers"
                        type="number"
                        size="small"
                        error={!!errors.requiredWorkers}
                        {...register("requiredWorkers")}
                        style={{ width: "16.5%", margin: 10 }}
                        onBlur={(e: any) => handleAutoSave('requiredWorkers', e.target.value.trim())}
                    />
                </div>
                <div className={styles.buttonDiv}>
                    <Button
                        variant="outlined"
                        disabled
                        style={{
                            marginRight: 20,
                            width: "25%",
                            height: 43,
                            backgroundColor: loading ? "white" : "#156bc2",
                            border: loading ? "2px solid green" : "none",
                            color: loading ? "green" : "white",
                        }}
                        size="large"
                    >
                        {loading ? <Spin style={{ color: "green" }} /> : 'Saved'}
                    </Button>
                </div>
                <div style={{ textAlign: "right", color: "#888", fontStyle: "italic" }}>
                    Created Date:{" "}
                    {shiftData?.createdDate
                        ? format(new Date(shiftData.createdDate), "dd/MM/yyyy")
                        : "N/A"}
                </div>
                {shiftData?.sentTime && (
                    <div style={{ textAlign: "right", color: "#888", fontStyle: "italic", marginTop: 3 }}>
                        Sent Date:{" "}
                        {format(new Date(shiftData.sentTime), "dd/MM/yyyy")}
                    </div>
                )}
            </form>
        </>
    );
}

export default EditShift;
